import {TeamActivities} from "../../components/Project/team_activities";
import {connect} from "react-redux";
import {mapStateToProps} from "../../store/helpers/mapState";
import {mapDispatchToProps} from "../../store/helpers/mapDispatch";
import React, {useEffect, useState} from "react";
import {getError} from "../../store/helpers/common_functions";
import PageLoading from "../../helpers/PageLoading";

const DeveloperTimeline = ({FetchDetails, loggedUser,SetSelectedMenu}) => {
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState();
    const [timeline, setTimeline] = React.useState([]);
    const [devTimeline, setDevTimeline] = React.useState([]);
    const [pages, setPages] = useState([]);
    const [devPages, setDevPages] = useState([]);
    const [activePage, setActivePage] = useState(1);
    const [activeDevPage, setActiveDevPage] = useState(1);

    const loadData = async () => {
        setLoading(true);
        setError(null);
        const resp = await FetchDetails(`/api/dashboard/project/timeline/?page=${activePage}`);
        setLoading(false);
        if (resp.status && resp.data.timeline?.length) {
            setTimeline(resp.data.timeline);
            setPages(resp.data.pages);
        } else {
            setError(getError(resp));
        }
        return resp;
    }

    const loadDataDev = async () => {
        setLoading(true);
        setError(null);
        const resp = await FetchDetails(`/api/dashboard/developer/timeline/?page=${activeDevPage}`);
        setLoading(false);
        if (resp.status && resp.data.timeline?.length) {
            setDevTimeline(resp.data.timeline);
            setDevPages(resp.data.pages);
        } else {
            setError(getError(resp));
        }
        return resp;
    }



    useEffect(() => {
        loadData().then();
    }, [FetchDetails, activePage]);

    useEffect(() => {
        loadDataDev().then();
    }, [FetchDetails, activeDevPage]);

    useEffect(()=>{
        SetSelectedMenu({
            menu:"timeline",
            title:"Timeline"
        })
    },[]);
    return (loading && !timeline) || error || !timeline ?
        <PageLoading error={loading ? null : error} onRefresh={loadData}/> : <div>
            <TeamActivities timeline={timeline} title={'Projects Timeline'} pages={pages} page={activePage} onPageChange={setActivePage}/>
            <TeamActivities timeline={devTimeline} title={'Developers Timeline'} pages={devPages} page={activeDevPage} onPageChange={setActiveDevPage}/>
        </div>
}


export default connect(mapStateToProps, mapDispatchToProps)(DeveloperTimeline);
